export default "__VITE_ASSET__BQUHD7L8__"